// @flow

// layouts
import layoutsLibrary from "../layouts";

export default (layoutConfig: { name: string } = { name: "ak3" }) => {
  const Icons = layoutsLibrary[layoutConfig.name].Icons || {};
  return Icons;
};
